import { Component, OnInit } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';

import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-turnos-dados',
  templateUrl: './turnos-dados.component.html',
  styleUrls: ['./turnos-dados.component.scss'],
  providers: [CommonService]
})
export class TurnosDadosComponent implements OnInit {
  private search;
  private counter:number;
  private dayCounter:number;

  public turnos:any[];
  public sobreturnos:any[];
  public profesionales:any[];
  public estados:any[];
  public selectedProfesional:any;
  public selectedTurno:any;
  public selectedEstado:any;
  public selectedDate:Date;
  public turnosP:any[];

  public day;
  public weekday;
  public month;
  public year;

  constructor(private commonService:CommonService, private modalService:NgbModal) { }

  ngOnInit() {
    this.selectedProfesional = 0;

    this.commonService.getProfesionales()
      .then(result => this.profesionales = result);
  }

  getTurnosP() {
    let profesionalId = this.selectedProfesional.id;

    Promise.all([
      this.commonService.getTurnos(profesionalId),
      this.commonService.getSobreturnos(profesionalId),
    ]).then(result => {
      this.turnos = result[0];
      this.sobreturnos = result[1];
    });
  }

  openE(content, t, table) {
    this.selectedTurno = t.id;
    this.selectedEstado = t.id_estado;

    this.commonService.getEstadosDelTurno()
      .then(result => this.estados = result.filter(e => {
        return e.descripcion === 'Entregado' || e.descripcion === 'Cobrado' || e.descripcion === 'Cancelado';
      }));

    this.modalService.open(content, {
      backdrop:'static'
    }).result.then(() => {
      this.updateEstado(table);
    }, () => {
    });
  }

  updateEstado(table) {
    var data = {
      idTurno:this.selectedTurno,
      idEstado:this.selectedEstado,
      table:table
    };
    
    this.commonService.updateEstadoTurno(data)
      .then(() => {
        alert("Estado actualizado correctamente");
        this.getTurnosP();
      });
  }

  openT(content, t) {
    this.counter = 0;
    this.dayCounter = 0;
    this.selectedTurno = t.id;
    this.selectedDate = new Date(t.fecha);

    this.search = {
      dia: this.getDia(),
      profesional: this.selectedProfesional.id,
      fecha: this.selectedDate
    };

    this.listTurnosP(false);

    this.modalService.open(content, {
      backdrop:'static'
    }).result.then(() => {
    }, () => {
    });
  }

  listTurnosP(isPrev) {
    this.commonService.searchTurnosP(this.search).then(result => {
      this.counter++;

      if (result.length === 0 && this.counter < 8) {
        if (isPrev) {
          this.search.fecha = moment(this.search.fecha).subtract(1,'d').toDate();
        } else {
          this.search.fecha = moment(this.search.fecha).add(1,'d').toDate();
        }
        this.search.dia = moment(this.search.fecha).weekday();

        if (this.search.dia === 6) {
          this.search.fecha = moment(this.search.fecha).add(2,'d').toDate();
          this.search.dia = moment(this.search.fecha).weekday();
        }

        if (this.search.dia === 0 && isPrev) {
          this.search.fecha = moment(this.search.fecha).subtract(2,'d').toDate();
          this.search.dia = 5;
        }

        this.listTurnosP(isPrev);
      } else {
        this.turnosP = result;
        this.composeFechas();
      }
    });
  }

  private composeFechas():void {
    let dias = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
      meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

    this.day = this.search.fecha.getDate();
    this.weekday = dias[this.search.fecha.getDay()];
    this.month = meses[this.search.fecha.getMonth()];
    this.year = this.search.fecha.getFullYear();
  }

  rescheduleTurno(tdp) {
    var data = {
      idTurno:this.selectedTurno,
      fecha:this.search.fecha,
      idTdp:tdp.id
    }

    this.commonService.rescheduleTurno(data)
      .then(() => {
        alert('Turno reagendado correctamente');
        this.getTurnosP();
      })
  }

  searchNext():void {
    let newDate = moment(this.search.fecha).add(1, 'd');
    this.search.fecha = newDate.toDate();
    this.search.dia = newDate.weekday(); 

    this.dayCounter++;
    this.counter = 0;
    this.turnosP = [];
    this.listTurnosP(false);
  }

  searchPrev():void {
    let newDate = moment(this.search.fecha).subtract(1, 'd');
    this.search.fecha = newDate.toDate();
    this.search.dia = newDate.weekday(); 

    if (this.search.dia === 0) {
      this.search.fecha = moment(this.search.fecha).subtract(2,'d').toDate();
      this.search.dia = 5;
    }

    this.dayCounter--;
    this.counter = 0;
    this.turnosP = [];
    this.listTurnosP(true);
  }

  private getDia() {
    let dia;

    if(!this.selectedDate) {
      this.selectedDate = moment().add(2, 'd').toDate();
    }

    dia = moment(this.selectedDate).weekday();

    if (dia === 6) {
      this.selectedDate = moment(this.selectedDate).add(2,'d').toDate();
      dia = 1;
    }

    if (dia === 0) {
      this.selectedDate = moment(this.selectedDate).add(1,'d').toDate();
      dia = 1;
    }

    return dia;
  }

  canSchedule(fecha) {
    return new Date(fecha) >= new Date();
  }

  removeTurno(turno) {
    var remove = confirm('¿Esta seguro de que quiere eliminar el turno?');

    if(remove) {
      this.commonService.removeTurno(turno.id)
        .then(()=> {
          alert('Turno eliminado');
          this.getTurnosP();
        });
    } else {
      return false;
    }
  }

  removeSobreturno(sobreturno) {
    var remove = confirm('¿Esta seguro de que quiere eliminar el sobreturno?');

    if(remove) {
      this.commonService.removeSobreturno(sobreturno.id)
        .then(()=> {
          alert('Sobreturno eliminado');
          this.getTurnosP();
        });
    } else {
      return false;
    }
  }

  print() {
    window.print();
  }
}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/home/turnos-dados/turnos-dados.component.ts